import { Box, CenterProps, Skeleton, Tbody, Td, Tr } from '@chakra-ui/react';
import { Center } from '@chakra-ui/react';
import { memo } from 'react';
import * as React from 'react';

export const TableNone: React.FC<CenterProps> = ({ children, ...props }) => {
  return (
    <Center p="10" h="xs" {...props}>
      <Box>{children}</Box>
    </Center>
  );
};

export const TableLoading: React.FC<{
  columns: number;
  rows?: number;
}> = memo(({ columns, rows = 5 }) => {
  return (
    <Tbody>
      {[...Array(rows)].map((_, i) => (
        <Tr key={i}>
          {[...Array(columns)].map((_, j) => (
            <Td key={j}>
              <Skeleton h="4" borderRadius="lg" />
            </Td>
          ))}
        </Tr>
      ))}
    </Tbody>
  );
});

TableLoading.displayName = 'TableLoading';

export const TableEmpty: React.FC = (props) => {
  return (
    <Tbody>
      <Tr>
        <Td colSpan={100}>
          <TableNone>{props.children}</TableNone>
        </Td>
      </Tr>
    </Tbody>
  );
};
